<template>
	<o-tour :ref="setup._tourTimeTicketReleaseNote">
		<o-tour-step
			:title="$t('common.tour.timeTicket.flexibility.title')"
			hide-finish
			target="toggleFlex">
			<div>
				{{ $t('common.tour.timeTicket.flexibility.description') }}
				<br>
				{{ $t('common.tour.timeTicket.flexibility.saveConfig') }}
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.hasData"
			:title="$t('common.tour.timeTicket.integration.title')"
			:target="setup.firstIntegratedCircle.bind(setup)">
			<div>
				{{ $t('common.tour.timeTicket.integration.description') }}
				<br>
				{{ $t('common.tour.timeTicket.integration.filterInfo') }}
			</div>
		</o-tour-step>

		<o-tour-step
			v-else
			size="lg">
			<div>
				<p>
					{{ $t('common.tour.timeTicket.integration.emptyState') }}
					<br><b style="color:var(--pink)">{{ $t('common.tour.timeTicket.integration.purpleIndicator') }}</b>
				</p>
				<div
					v-if="setup.hasData === 0"
					class="row row--center">
					<p style="width: 18.75rem;">
						<time-ticket-week-card
							:time-ticket="{
								weekNumber: 42,
								year: 2023,
								qtyToValidate: 5,
								qtyValidated: 10,
								qtyPending: 0,
								qtyIntegrated: 1,
							} as Armado.TimeTicketWeekYear"/>
					</p>
				</div>
			</div>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TimeTicketWeekCard from '@/components/time-ticket/TimeTicketWeekCard.vue';
// #region Setup
import TourTimeTicketReleaseNoteSetup from './TourTimeTicketReleaseNoteSetup';
import type { TourTimeTicketReleaseNoteEmits, TourTimeTicketReleaseNoteProps } from './TourTimeTicketReleaseNoteSetup';
const emits = defineEmits<TourTimeTicketReleaseNoteEmits>() as TourTimeTicketReleaseNoteEmits;
const props = withDefaults(defineProps<TourTimeTicketReleaseNoteProps>(), TourTimeTicketReleaseNoteSetup.defaultProps);
const setup = new TourTimeTicketReleaseNoteSetup(props, emits);
// #endregion
</script>
